export default __webpack_public_path__ + "static/media/tanya-barbiero.559c4dd6.png";